import {TimelineSeries} from './widget.timelineSeries';

export class TimelineData {
    Data: TimelineSeries[];

    IsValid(): boolean {
        if (this.Data != null && this.Data.length > 0) {
            return true;
        }
        return false;
    }
}
